import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

// Attach JWT token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("email");
      if (window.location.pathname !== "/" && !window.location.pathname.startsWith("/book")) {
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

// Also install same interceptors on global axios so existing `axios.*` usages
// inside dashboard pages get the token attached automatically.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("email");
      if (window.location.pathname !== "/" && !window.location.pathname.startsWith("/book")) {
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
